import { useTranslations } from 'next-intl'

import { PropertyType as PropertyTypeEnum } from '@/entities/room'

import { usePropertyTypes } from './option'
import { FilterType } from '../../../model/filter'
import { Title, List, Item } from '../../common/layout'

type Props = {
  type: FilterType
  ref: (element: HTMLDivElement) => void
  className?: string
  selected: (value: PropertyTypeEnum) => boolean
  onChange: (value: PropertyTypeEnum) => void
}

export const PropertyTypesInDefaultView = ({
  type,
  ref,
  className,
  selected,
  onChange,
}: Props) => {
  const t = useTranslations('filter')

  const { PROPERTY_TYPES } = usePropertyTypes()

  const handlePropertyTypeChange = (value: PropertyTypeEnum) => () => {
    onChange(value)
  }

  return (
    <div className={className} ref={ref}>
      <Title>{t('property_type.title')}</Title>
      <List>
        {PROPERTY_TYPES.map(({ title, value }) => (
          <Item
            key={title}
            type={type}
            selected={selected(value)}
            onClick={handlePropertyTypeChange(value)}
            className="whitespace-nowrap"
          >
            <p className="flex h-11 items-center justify-center">
              {title.replace(/\n/g, '')}
            </p>
          </Item>
        ))}
      </List>
    </div>
  )
}
